import { render, staticRenderFns } from "./KioskTab.vue?vue&type=template&id=3f1ccf8e"
import script from "./KioskTab.vue?vue&type=script&lang=js"
export * from "./KioskTab.vue?vue&type=script&lang=js"
import style0 from "./KioskTab.vue?vue&type=style&index=0&id=3f1ccf8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports